// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d8fdf884","455":"2854b358","977":"fdad22c3"}[chunkId] + ".chunk.js";
};